// 1.ajax工具函数层
import Axios from "axios";
import jwtDecode from 'jwt-decode'
import { refreshToken, userTokenRefresh } from "@/api/acount.js";
import { Message } from 'element-ui';
import router from '@/router'
// 2.服务器地址
const request = Axios.create({
  // baseURL: 'http://192.168.130.10/'
  // baseURL: 'http://boboyang.nat300.top/'//测试环境
  baseURL: 'https://pad.lovehome.net.cn/'//生产环境
  // baseURL:'http://192.168.130.151:8089/'
  // baseURL:process.env.VUE_APP_BASE_API
  // baseURL: 'http://192.168.130.154:7000/'//cyf
})
// 3.超时时间、
request.defaults.timeout = 30000

// 4.请求拦截器
request.interceptors.request.use((config) => {
  if (sessionStorage.getItem('Authorization')) {
    config.headers.Authorization = 'Bearer ' + sessionStorage.getItem('Authorization');
  }
  return config
}, (err) => {
  return Promise.reject(err)
})

// 5.响应拦截器
request.interceptors.response.use((response) => {
  return response
}, (err) => {
  // console.log(err.response.status)
  if (err.response.status == 401) {

    if (sessionStorage.getItem('loginType') == '0') {
      const params = {
        token: sessionStorage.getItem('Authorization'),
        refreshToken: sessionStorage.getItem('refreshToken'),
      };
      refreshToken(params).then((res) => {
        if (res.data.statusCode == 200) {
          const code = jwtDecode(res.data.data.token);
          const storeId = code.department;
          const fullName = code.fullName;
          sessionStorage.setItem('Authorization', res.data.data.token);
          sessionStorage.setItem('refreshToken', res.data.data.refreshToken);
          sessionStorage.setItem("storeId", storeId);
          sessionStorage.setItem("fullName", fullName);
          location.reload();
        } else {
          location.reload();
          Message.error(res.data.exception);
          return false;
        }
      }).catch((err) => {
        console.log(err);
        Message.error("刷新获取token错误,登录失败!");
        sessionStorage.clear();
        router.push({ path: '/login' })
      });
      return false;
    } else if (sessionStorage.getItem('loginType') == '1') {
      const params = {
        token: sessionStorage.getItem('Authorization'),
        refreshToken: sessionStorage.getItem('refreshToken'),
      };
      userTokenRefresh(params).then((res) => {
        if (res.data.statusCode == 200) {
          const code = jwtDecode(res.data.data.token)
          const storeId = code.department;
          const fullName = code.fullName;
          sessionStorage.setItem('Authorization', res.data.data.token)
          sessionStorage.setItem('refreshToken', res.data.data.refreshToken)
          sessionStorage.setItem("storeId", storeId);
          sessionStorage.setItem("fullName", fullName);
          location.reload();
        } else {
          Message.error(res.data.exception);
          location.reload();
          return false;
        }
      }).catch((err) => {
        console.log(err);
        Message.error("刷新获取token错误,登录失败!");
        sessionStorage.clear();
        router.push({ path: '/login' })
      });
      return false;
    }
  }

  return Promise.reject(err)
})

export default request
